import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import { StyledLogosAndHeaderSecurityComponent } from "./logos-and-header-security-component.scss";
import SecurityLogos from "segments/desktop/core-components/security-logos/security-logos";
import Title from "segments/desktop/core-components/title/title";
import { LG } from "constants/sizes";
class LogosAndHeaderSecurityComponent extends PureComponent {
    render() {
        const { title, titleSize } = this.props;
        return /*#__PURE__*/ _jsxs(StyledLogosAndHeaderSecurityComponent, {
            className: "logos-and-header-security-component",
            children: [
                /*#__PURE__*/ _jsx(Title, {
                    title: title,
                    titleSize: titleSize
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "security-logos-wrapper",
                    children: /*#__PURE__*/ _jsx(SecurityLogos, {})
                })
            ]
        });
    }
}
export { LogosAndHeaderSecurityComponent as default };
LogosAndHeaderSecurityComponent.defaultProps = {
    title: "Compliance certifications and regulations",
    titleSize: LG,
    paddingTop: "64px",
    paddingBottom: "64px"
};
